/** Member-facing numeric precision for the GHG inventory report. */

export function formatWholeMt(value: number): string {
  return Math.round(value).toLocaleString('en-US');
}

export function formatSharePercent(share0to1: number): string {
  return `${(share0to1 * 100).toFixed(1)}%`;
}

/** Per-capita MT: 1 decimal, or 2 decimals when the absolute value is below 1. */
export function formatPerCapitaMt(value: number): string {
  const abs = Math.abs(value);
  return abs < 1 && abs > 0 ? value.toFixed(2) : value.toFixed(1);
}

export function formatDensity(value: number): string {
  return Math.round(value).toLocaleString('en-US');
}

export function formatHouseholdMt(value: number): string {
  return value.toFixed(1);
}

export function formatCount(value: number): string {
  return Math.round(value).toLocaleString('en-US');
}

export function formatGeneratedDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function percentChange(from: number, to: number): number | null {
  if (!Number.isFinite(from) || from === 0 || !Number.isFinite(to)) return null;
  return ((to - from) / from) * 100;
}

export function formatSignedPercent(value: number): string {
  const abs = Math.abs(value).toFixed(1);
  if (value > 0) return `+${abs}%`;
  if (value < 0) return `−${abs}%`;
  return '0.0%';
}
